import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Image, Spinner } from 'react-bootstrap';
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import config from '../../config';
import { toast } from 'react-toastify';

const Corporate = () => {

    useEffect(() => {
        document.title = `Corporate | Agile Seekers`;
        document.getElementById('bodywrap').className = 'corporatemain';
    }, []);

    // Partner form all field
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [phonenumber, setPhonenumber] = useState("");
    const [companyname, setCompanyname] = useState("");
    const [messages, setMessages] = useState("");

    const [errors, setErrors] = useState({});
    const [isSubmittingPartner, setIsSubmittingPartner] = useState(false);

    // All Validations
    const validate = () => {
        const newErrors = {};

        if (!firstname) {
            newErrors.firstname = "First Name is required";
        }

        if (!lastname) {
            newErrors.lastname = "Last Name is required";
        }

        if (!email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "Email address is invalid";
        }

        if (!phonenumber) {
            newErrors.phonenumber = "Phone Number is required";
        }

        if (!companyname) {
            newErrors.companyname = "Company Name is required";
        }

        if (!messages) {
            newErrors.messages = "Messages is required";
        }

        return newErrors;
    };

    const partner_submit = async () => {
        const validationErrors = validate();

        if (Object.keys(validationErrors).length === 0) {
            setIsSubmittingPartner(true);
            let item = {};
            item.first_name = firstname;
            item.last_name = lastname;
            item.email = email;
            item.phone_number = phonenumber;
            item.message = messages;
            item.company_name = companyname;

            try {
                let response = await fetch(`${config.API_BASE_URL}/corporate_training_form`, {
                    method: "post",
                    body: JSON.stringify(item),
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                response = await response.json();

                if (response.status === 1) {

                    // Zoho Lead API Code Start
                    const payload = {
                        data: [
                            {
                                Company: "Agile",
                                First_Name: firstname,
                                Last_Name: lastname,
                                Email: email,
                                Phone: phonenumber,
                                Lead_Status: "New",
                                Lead_Source: "Direct",
                                Page_URL: window.location.href
                            },
                        ],
                        trigger: ["approval", "workflow", "blueprint"],
                    };

                    try {
                        const response = await fetch(`${config.API_BASE_URL}/zoho/corporate_training_form`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(payload),
                        });

                        const result = await response.json();

                        if (result.status === 1) {
                            setErrors({});

                            // toast.success(result.message);
                        } else {
                            // toast.error(result.message);
                            console.error("Zoho Error:", result);
                        }
                    } catch (error) {
                        console.error("Fetch error:", error);
                    }
                    // Zoho Lead API Code End

                    setErrors({});
                    setFirstname("");
                    setLastname("");
                    setEmail("");
                    setPhonenumber("");
                    setCompanyname("");
                    setMessages("");

                    // Display alert with message
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                toast.error("An unexpected error occurred.");
            } finally {
                setIsSubmittingPartner(false); // End the loading state
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <>
            <Navbar />

            <section>
                <Container>
                    <Row>
                        <Col className='corporate-top'>
                            <h2>Corporate </h2>
                            <h6>Last updated: July 23, 2023</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='corporate-content'>

                            <h3>Unlock Your Team’s Potential with AgileSeekers</h3>
                            <p>At AgileSeekers, we believe that continuous learning is the key to staying competitive in today’s fast-paced world. Our industry-recognized training programs equip professionals with the latest skills and knowledge, helping organizations bridge the gap between strategy and execution. We have successfully empowered teams across industries with real-world expertise, ensuring they achieve measurable growth and success.</p>

                            <h3>Trusted by Fortune 100 and Leading Global Enterprises</h3>
                            <p>Global enterprises, including Fortune 100 companies and over 730 SMEs, trust AgileSeekers for our immersive, hands-on training approach. Our commitment to excellence ensures that every session is engaging, relevant, and impactful, driving meaningful transformation at both individual and organizational levels.</p>

                            <h3>Why Choose AgileSeekers?</h3>
                            <h3>✅ Learn by Doing</h3>
                            <p>We focus on hands-on training, so your team gets real-world experience and feels confident applying new skills on the job.</p>

                            <h3>✅ Practical & Impactful Learning</h3>
                            <p>Our programs are designed to provide useful, actionable knowledge that leads to real improvements in the workplace.</p>

                            <h3>✅ Training That Fits Your Role</h3>
                            <p>We customize learning based on job roles and company needs, helping teams work better together and be more productive.</p>

                            <h3>✅ Stay Ahead with Future-Ready Skills</h3>
                            <p>We equip your team with the latest skills to keep up with industry changes and drive innovation.</p>

                            <h3>✅ Seamless Learning with Full Support</h3>
                            <p>We manage everything—from personalized learning plans to progress tracking—so your team gets the most out of their training.</p>

                            <h3>Our Corporate Training Offerings</h3>
                            <h3>🔹 Agile & Scrum</h3>
                            <ul>
                                <li>Scaled Agile Framework (SAFe) Certifications – SAFe Agilist, SAFe Scrum Master, SAFe POPM, RTE & more</li>
                                <li>Scrum Alliance - Certified Scrum Master (CSM) & Certified Scrum Product Owner (CSPO)</li>
                                <li>Scrum.org - Professional Scrum Master (PSM) & Professional Scrum Product Owner (PSPO) – </li>
                                <li>Technical Agility Workshops</li>
                                <li>Customized Agile Training (1-5 Days)</li>
                            </ul>

                            <h3>🔹 Project Management & DevOps</h3>
                            <ul>
                                <li>Agile Project Management Training</li>
                                <li>DevOps Foundations & Advanced Workshops</li>
                            </ul>

                            <h3>Elevate Your Workforce with AgileSeekers</h3>
                            <p>We offer comprehensive Agile and Scaled Agile solutions tailored to your organization's needs.</p>
                            <p>Fill out the form below, and we’ll get in touch with you soon!</p>

                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="contact-form mt-5">
                <Container>
                    <Row className="justify-content-md-center">
                        <Col md={6} className="cf-left">
                            <Col>
                                <h3>Corporate Training</h3>
                                <Form >
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="fname">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter First Name"
                                                value={firstname}
                                                onChange={(e) => setFirstname(e.target.value)}
                                            />
                                            {/* First name validation */}
                                            {errors.firstname && (
                                                <div className="text-danger">{errors.firstname}</div>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="lname">
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Last Name"
                                                value={lastname}
                                                onChange={(e) => setLastname(e.target.value)}
                                            />
                                            {/* Last name validation */}
                                            {errors.lastname && (
                                                <div className="text-danger">{errors.lastname}</div>
                                            )}
                                        </Form.Group>
                                    </Row>

                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter Email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}

                                        />
                                        {/* Email validation */}
                                        {errors.email && (
                                            <div className="text-danger">{errors.email}</div>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="phone">
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            value={phonenumber}
                                            onChange={(e) => setPhonenumber(e.target.value)}
                                        />
                                        {/* Phone Number validation */}
                                        {errors.phonenumber && (
                                            <div className="text-danger">{errors.phonenumber}</div>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="cname">
                                        <Form.Label>Company Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Company Name"
                                            value={companyname}
                                            onChange={(e) => setCompanyname(e.target.value)}
                                        />
                                        {/* Company Name validation */}
                                        {errors.companyname && (
                                            <div className="text-danger">{errors.companyname}</div>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="message">
                                        <Form.Label>Messages</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            placeholder="Enter Messages"
                                            value={messages}
                                            onChange={(e) => setMessages(e.target.value)}
                                        />
                                        {/* Message validation */}
                                        {errors.messages && (
                                            <div className="text-danger">{errors.messages}</div>
                                        )}
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="button"
                                        onClick={partner_submit}
                                        disabled={isSubmittingPartner}
                                    >
                                        {isSubmittingPartner ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="mx-2"
                                                />
                                                Loading...
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </Button>
                                </Form>
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
        </>
    )

}
export default Corporate;    